import { ITypeNode, useFormBuilder } from '../../Context/FormBuilderContext';
import { FormSettings } from './FormSettings';
import { ImageSettings } from './ImageSettings';
import { InputSettings } from './InputSetting';
import { ListSettings } from './ListSettings';
import { OutputSettings } from './OutputSettings';
import { ShortTextSettings } from './ShortTextSettings';
import { SubmitSettings } from './SubmitSettings';
import { TitleSettings } from './TitleSettings';

export function SettingsContainer() {
  const { selectNode, settingsFormMode } = useFormBuilder();

  console.log(selectNode, settingsFormMode);

  return (
    <>
      {selectNode && (
        <div
          key={selectNode.id}
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            width: '230px',
            overflowY: 'auto',
            background: 'white',
            border: '1px solid #EAECF0',
            borderRadius: '8px',
            height: 'calc(100vh - 215px)',
          }}
        >
          {selectNode.type === ITypeNode.TITLE && (
            <TitleSettings key={`title-${selectNode.id}`} node={selectNode} />
          )}

          {selectNode.type === ITypeNode.SHORT_TEXT && (
            <ShortTextSettings
              key={`shorttext-${selectNode.id}`}
              node={selectNode}
            />
          )}

          {selectNode.type === ITypeNode.SUBMIT && (
            <SubmitSettings key={`submit-${selectNode.id}`} node={selectNode} />
          )}

          {selectNode.type === ITypeNode.IMAGE && (
            <ImageSettings key={`image-${selectNode.id}`} node={selectNode} />
          )}

          {selectNode.type === ITypeNode.INPUT && (
            <InputSettings key={`input-${selectNode.id}`} node={selectNode} />
          )}

          {selectNode.type === ITypeNode.OUTPUT && (
            <OutputSettings key={`output-${selectNode.id}`} node={selectNode} />
          )}

          {selectNode.type === ITypeNode.LIST && (
            <ListSettings key={`list-${selectNode.id}`} node={selectNode} />
          )}
        </div>
      )}

      {settingsFormMode && !selectNode && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            width: '230px',
            overflowY: 'auto',
            background: 'white',
            border: '1px solid #EAECF0',
            borderRadius: '8px',
            height: 'calc(100vh - 200px)',
          }}
        >
          <FormSettings />
        </div>
      )}
    </>
  );
}
